import React, { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLImageElement> {
  width?: number;
  height?: number;
  objectFit?: React.CSSProperties['objectFit'];
  loading?: React.ImgHTMLAttributes<HTMLImageElement>['loading'];
  src: string;
  alt?: string;
  className?: string;
}

const DoctornowImage = (props: Props) => {
  return (
    <img
      className={props.className}
      src={props.src}
      alt={props.alt ?? '이미지'}
      loading={props.loading}
      style={{ width: props.width, height: props.height, objectFit: props.objectFit }}
    />
  );
};

export default DoctornowImage;
